import { axis, start, size, dims, axisOp, startOp, sizeOp, normalizeShape, getAbsoluteShape } from '../shape';

export default class MinimapInstance {
  constructor(i, options, instance) {
    const grid = options.grid[i];
    if (!grid.id) {
      grid.id = 'minimap-' + i;
    }

    this.id = grid.id;
    this.instance = instance;
    this.dataZoomId = {};
    axis.forEach((a) => {
      this.dataZoomId[a] = `dataZoom-${a}-${this.id}`;
    });

    this.windowId = `minimapWindow-${this.id}`;
    this.processOptions(i, options);
    this.instance.once('render', () => {
      // console.log('minimap on render');
      _.defer(() => {
        this.resetWindow();
      });
    });

    this.instance.on('resize', () => {
      // console.log('minimap on resize');
      _.defer(() => {
        this.resetWindow();
      });
    });
  }

  processOptions(i, options) {    
    const grid = options.grid[i];
    this.sourceAxis = axis.reduce((r, a) => {
      r[a] = {};
      return r;
    }, {});

    this.sourceAxisZoom = axis.reduce((r, a) => {
      r[a] = false;
      return r;
    }, {});

    _.defaultsDeep(grid, {
      id: 'minimap-' + i,
      dataZoomScale: 100,
      showSeries: [],
      windowStyle: {
        fill: 'rgba(255,255,255,0.1)',
        stroke: 'rgba(255,255,255,0.2)',
        lineWidth: 1,
        shadowColor: '#000000',
        shadowBlur: 15,
      },
    });
    normalizeShape(grid);
    if (grid.dataZoomScale < 100) {
      grid.dataZoomScale = 100;
    }

    this.dataZoomScale = grid.dataZoomScale;

    grid.showSeries = grid.showSeries.filter((s) => (_.isString(s) && s) || s.seriesName);
    const gridSeriesOptions = funJSON.stringify(grid.showSeries);
    if (this.gridSeriesOptions !== gridSeriesOptions) {
      this.gridSeriesOptions = gridSeriesOptions;
    }

    let series = options.series.filter(
      (s) =>
        !grid.showSeries ||
        !grid.showSeries.length ||
        grid.showSeries.some((serie) => serie === s.name || serie.seriesName === s.name)
    );
    if(!series.length) {series = options.series;}

    const miniClones = [];
    series.forEach((s, si) => {
      let clone = _.cloneDeepWithFunctions(s);
      _.set(clone,'label.show', false);
      let cfg = grid.showSeries.find((serie) => serie === s.name || serie.seriesName === s.name);
      if(!cfg) {cfg = grid.showSeries[si];}

      cfg = _.defaults(cfg || {}, {});
      if (cfg.overrideOptions) {
        delete cfg.overrideOptions.type;
        clone = _.merge(clone, cfg.overrideOptions);
      }

      clone.name = '';
      if (cfg.filterData) {
        clone.data = _.filter(clone.data, cfg.filterData);
      }

      clone.isMinimap = true;

      axis.forEach((a) => {
        if (!clone[`${a}AxisIndex`]) {
          clone[`${a}AxisIndex`] = 0;
        }

        if (this.sourceAxis[a][clone[`${a}AxisIndex`]] === undefined) {
          this.sourceAxis[a][clone[`${a}AxisIndex`]] = options[`${a}Axis`].length;
          if (
            _.find(options.dataZoom, (zz) => {
              return zz[`${a}AxisIndex`] && zz[`${a}AxisIndex`].includes(clone[`${a}AxisIndex`]);
            })
          ) {
            this.sourceAxisZoom[a] = true;
          }

          let axisClone = _.cloneDeepWithFunctions(options[`${a}Axis`][clone[`${a}AxisIndex`]]);
          delete axisClone.id;
          delete axisClone.name;

          if (grid[`${a}AxisOverride`]) {
            delete grid[`${a}AxisOverride`].id;
            delete grid[`${a}AxisOverride`].name;
            delete grid[`${a}AxisOverride`].type;
            _.merge(axisClone, grid[`${a}AxisOverride`]);
          }

          axisClone.gridIndex = i;
          axisClone.name = (axisClone.name || '') + `_minimap_${a}_${i}`;
          axisClone.nameTextStyle = {color : 'transparent'};
          options[`${a}Axis`].push(axisClone);
        }

        clone[`${a}AxisIndex`] = this.sourceAxis[a][clone[`${a}AxisIndex`]];
        // let cloneAxis = options[`${a}Axis`][clone[`${a}AxisIndex`]];
        // if(cloneAxis.min===undefined ||cloneAxis.dataMin){

        // }
      });

      miniClones.push(clone);
    });
    // console.log('minimap.processOptions',miniClones, this);
    options.series = [...options.series, ...miniClones];

    axis.forEach((a) => {
      if(this.sourceAxisZoom[a]){
        options.dataZoom.push({
          id: `dataZoom-${a}-${grid.id}`,
          [`${a}AxisIndex`]: _.uniq(_.map(miniClones, `${a}AxisIndex`)),
          //[`${axisOp[a]}AxisIndex`]: [],
          type: 'inside',
          filterMode: 'none',
          moveOnMouseMove: false,
          moveOnMouseWheel: false,
          preventDefaultMouseMove: true,
          zoomOnMouseWheel: false,
        });        
      }
    });

    // console.log('minimap.processOptions.dataZoom',options.dataZoom);

    _.defaults(options, { graphic: { elements: [] } });
    const pos = {};
    options.graphic.elements.push({
      type: 'rect',
      id: `minimapWindow-${grid.id}`,
      style: grid.windowStyle,
    },
    {
      type: 'rect',
      id: `minimapWindowGlass-${grid.id}`,
      left:0,
      bottom:0,      
      style: {
        fill: 'rgba(0,0,0,0.0)',
        stroke: 'rgba(0,0,0,0)',
        lineWidth: 0        
      },
      draggable: true,
      z: 100000,
      ondragstart: (ev) => {
        pos.left = ev.offsetX;
        pos.top = ev.offsetY;
        pos.options = this.instance.chart.getOption();
        // let windowGraphic = this.getWindowGraphic();
        // console.log(windowGraphic.shape.x, windowGraphic.shape.y, ev);
      },
      ondrag: (ev) => {
        this.onWindowDrag(
          {
            left: ev.offsetX - pos.left,
            bottom: pos.top - ev.offsetY,
          },
          pos.options
        );
        //console.log(windowGraphic.left, windowGraphic.top,ev);
      },
      ondragend: (ev) => {
        // let windowGraphic = this.getWindowGraphic();
        // console.log(windowGraphic.shape.x, windowGraphic.shape.y, ev);
      },
      onmousewheel: (ev) => {
        this.dataZoomScale += ev.wheelDelta * 4*(this.dataZoomScale/100);
        if (this.dataZoomScale < 100) {
          this.dataZoomScale = 100;
        }

        
        this.resetWindow();
        // console.log(ev);
      },
      
    },
    );
  }

  getWindowGraphicIndex(options) {
    if (options === undefined) {
      options = this.instance.chart.getOption();
    }

    let graphic = options.graphic;
    if (Array.isArray(graphic)) {
      graphic = graphic[0];
    }

    return _.findIndex(graphic.elements, { id: this.windowId });
  }

  getWindowGraphic(options, windowIndex) {
    if (options === undefined) {
      options = this.instance.chart.getOption();
    }

    let graphic = options.graphic;
    if (Array.isArray(graphic)) {
      graphic = graphic[0];
    }

    if (windowIndex === undefined) {
      return _.find(graphic.elements, { id: this.windowId });
    }

    return graphic.elements[windowIndex];
  }

  resetWindow(options) {
    if (options === undefined) {
      options = this.instance.chart.getOption();
      if(!options) {return;}
    }

    axis.forEach((a) => {
      const axisIndex = Number(_.keys(this.sourceAxis[a])[0]);
      const dz = _.find(options.dataZoom, (dz) => {
        return _.includes(dz[`${a}AxisIndex`], axisIndex);
      });
      if (!dz) {
        return;
      }

      this.onSourceChange(a, { start: dz.start, end: dz.end }, options);
      _.defer(()=>this.instance.fire('datazoom'));
    });
  }

  onWindowDrag(offset, options) {
    axis.forEach((a) => {
      if (offset[start[a]]) {
        const axisIndex = Number(_.keys(this.sourceAxis[a])[0]);
        const dz = _.find(options.dataZoom, (dz) => {
          return _.includes(dz[`${a}AxisIndex`], axisIndex);
        });
        if (!dz) {
          return;
        }

        const dzSize = dz.end - dz.start;
        const wnd = this.getWindowGraphic(options);
        const dzOffset = (offset[start[a]] * dzSize) / wnd.shape[size[a]];
        let newStart = dz.start + dzOffset;
        let newEnd = dz.end + dzOffset;
        if (newStart < 0) {
          newEnd = dzSize;
          newStart = 0;
        } else if (newEnd > 100) {
          newStart = 100 - dzSize;
          newEnd = 100;
        }

        this.onSourceChange(a, { start: newStart, end: newEnd });
        this.instance.fire('datazoom');
      }
    });
  }

  sync(a, { start: dzStart, end: dzEnd }, options) {

    // const { start: oldStart, end: oldEnd } = this.lastMap;
    // // const options = this.instance.chart.getOption();
    // console.log(a + ' sync:',dzStart-oldStart,dzEnd-oldEnd);
    // const axisIndex = Number(_.keys(this.sourceAxis[a])[0]);
    //     const dz = _.find(options.dataZoom, (dz) => {
    //       return _.includes(dz[`${a}AxisIndex`], axisIndex);
    //     });
    //     if (!dz) {
    //       return;
    //     }

    // const dzSize = dz.end - dz.start;

    // this.dataZoomScale = dzEnd - dzStart;
    // const wnd = this.getWindowGraphic(options);
    // const offset = {};
    // offset[start[a]]=(dzStart-oldStart) * wnd.shape[size[a]] / dzSize;
    // this.onWindowDrag(offset, options)
      


    // this.onSourceChange(
    //   { start, end },
    //   options
    // );
  }

  onSourceChange(a, { start: dzStart, end: dzEnd }, options) {
    this.lastDz = { start: dzStart, end: dzEnd };
    options = options || this.instance.chart.getOption();
    // console.log('onSourceChange: ' + a, dzStart, dzEnd, options);
    const dataZoomIndex = _.findIndex(options.dataZoom, { id: this.dataZoomId[a] });
    let patch = {
      dataZoom: [],
    };
    for (let i = 0; i < dataZoomIndex; i++) {
      patch.dataZoom[i] = {};
      let ax = options.dataZoom[i][`${a}AxisIndex`];
      if (
        ax &&
        (this.sourceAxis[a][ax] || (Array.isArray(ax) && ax.some((ax) => this.sourceAxis[a][ax])))
      ) {
        patch.dataZoom[i].start = dzStart;
        patch.dataZoom[i].end = dzEnd;
      }
      // if(this.sourceAxis[a][i]!==undefined)
    }

    const dzSize = dzEnd - dzStart;
    const dzScale = 10000 / dzSize;

    let dataZoomScale = Math.min(dzScale, this.dataZoomScale);

    const gridShape = this.getRect(options);
    // console.log('gridShape.height: ', gridShape.height, gridShape[sizeOp[a]]);
    let windowSize = (dzSize * gridShape[size[a]] * dataZoomScale) / 10000;
    if(windowSize<10){
      dataZoomScale = 100000 / (dzSize * gridShape[size[a]]);
      this.dataZoomScale = dataZoomScale;
      windowSize=10;      
    }

    // console.log(this.dataZoomScale+'->'+dataZoomScale);

    const center = dzStart + dzSize / 2;

    const mapSize = 10000 / dataZoomScale;
    // dzSize/mapSize
    let mapStart = center - mapSize / 2;

    let mapEnd = mapStart + mapSize;
    // let mapStart = (dzStart * 100) / dataZoomScale;
    // let mapSize = (dzSize * dataZoomScale) / 100;

    _.set(patch, 'graphic.elements', []);

    const windowIndex = this.getWindowGraphicIndex(options);

    for (let i = 0; i < windowIndex; i++) {
      patch.graphic.elements[i] = {};
    }



    let windowStart = gridShape[start[a]] + gridShape[size[a]] / 2 - windowSize / 2;

    // console.log({ mapStart, mapEnd });
    if (mapStart < 0) {
      windowStart += (mapStart * gridShape[size[a]] * dataZoomScale) / 10000;
      mapEnd -= mapStart;
      mapStart = 0;
    }
 
    if (mapEnd > 100) {
      windowStart += ((mapEnd - 100) * gridShape[size[a]] * dataZoomScale) / 10000;
      mapStart -= mapEnd - 100;
      mapEnd = 100;
    }

    patch.dataZoom[dataZoomIndex] = {
      start: mapStart,
      end: mapEnd,
    };

    this.lastMap = {
      start: mapStart,
      end: mapEnd,
    };

    patch.graphic.elements[windowIndex] = {
      [start[a]]: windowStart,
      shape: {
        [size[a]]: windowSize,
      },
    };
    patch.graphic.elements[windowIndex+1] = {      
      left: gridShape.left,
      bottom:gridShape.bottom,
      shape: {
        width: gridShape.width,
        height:gridShape.height,
      },
    };
    //const windowGraphic = this.getWindowGraphic(options, windowIndex);

    if (!this.sourceAxisZoom[axisOp[a]]) {
      _.merge(patch.graphic.elements[windowIndex], {
        [startOp[a]]: gridShape[startOp[a]],
        shape: {
          [sizeOp[a]]: gridShape[sizeOp[a]],
        },
      });
    }

    // console.log('window: ', JSON.stringify(patch.graphic.elements[windowIndex], null, 2));

    this.instance.chart.setOption(patch, false, true);
  }

  getRect(options) {
    if (!options) {
      options - this.instance.chart.getOption();
    }

    let gridShape = normalizeShape(_.find(options.grid, { id: this.id }));

    const chartRect = this.instance.getRect();

    return getAbsoluteShape(gridShape, chartRect);
  }
}






